import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/sales'

export default defineStore('dashboard-sales',
  storeModule.createStoreModule('dashboard-sales', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
